import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalizationModule } from '@abp/ng.core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ErrorFormControlDirective } from '@digiwall/core';

@Component({
  selector: 'document-planning-group-dialog',
  templateUrl: './planning-group-dialog.component.html',
  imports: [LocalizationModule, ReactiveFormsModule, ErrorFormControlDirective],
})
export class PlanningGroupDialogComponent {
  /** Localization key for the dialog title; caller overrides for edit vs. create. */
  public titleKey = 'Doc::Planning:NewGroup';

  public set label(value: string | undefined) {
    this.form.patchValue({ label: value ?? '' });
  }

  protected readonly modal = inject(NgbActiveModal);
  private readonly fb = inject(FormBuilder);

  protected readonly form: FormGroup = this.fb.group({
    label: ['', [Validators.required]],
  });

  protected confirm(): void {
    if (this.form.invalid) {
      return;
    }
    this.modal.close((this.form.value.label as string).trim());
  }
}
